// extracted by mini-css-extract-plugin
export default {"supplementItem":"Hp1VC8PDTk_Bfad_PnoM","inputBox":"CkurDALBTjhB8sb59NdX","addBtn":"pm6DxGidYqUJqg9dUk5t"};